import { Separator } from '@/vdp/VehicleInfo/Terms/Terms.styles';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import Badges from '../Badges';

export default function BasicInfo() {
  const {
    make = '',
    mileage = 0,
    model = '',
    modelOEM = '',
    trim = '',
    trimOEM = '',
    year = ''
  } = useGetVehicleDetails();

  return (
    <div className="flex flex-col gap-lg">
      <Badges />
      <div className="flex flex-col gap-sm">
        <div className="flex items-center justify-between">
          <div className="line-clamp-2 self-end text-text-strong t-heading-lg sm:self-center lg:t-heading-2xl">
            {year} {make} {modelOEM || model}
          </div>
        </div>
        <div className="flex w-full flex-wrap items-center gap-x-sm overflow-hidden text-text-strong t-body-sm">
          <span className="w-fit">{trimOEM || trim}</span>
          <Separator />
          <span className="w-fit">{mileage.toLocaleString()} miles</span>
        </div>
      </div>
    </div>
  );
}
